import { createFileRoute } from '@tanstack/react-router';
import CreateCase from '../../../../Components/CreateCase';
import { useCaseViewPermission } from '../../../../Hooks/useCaseViewPermission';

export const Route = createFileRoute('/(main)/_layout/cases/new')({
  component: RouteComponent,
});

function RouteComponent() {
  useCaseViewPermission();
  return <CreateCase />;
}
